import { updateContactInfoInitialState } from './state';
const reducer = (state, action) => {
    switch (action.type) {
        case 'email':
            return {
                ...state,
                email: action.payload,
            };
        case 'mobile':
            return {
                ...state,
                mobile: action.payload,
            };
        case 'reset':
            return { ...updateContactInfoInitialState };
        default:
            return state;
    }
};
const updateContactInfoReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cUpdate contact info form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default updateContactInfoReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVkdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy93aWRnZXRzL0NvbnRhY3RJbmZvcm1hdGlvbi9mb3JtL3JlZHVjZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLDZCQUE2QixFQUEwQixNQUFNLFNBQVMsQ0FBQztBQUVoRixNQUFNLE9BQU8sR0FBRyxDQUFDLEtBQTZCLEVBQUUsTUFBK0IsRUFBMEIsRUFBRTtJQUN2RyxRQUFRLE1BQU0sQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUNsQixLQUFLLE9BQU87WUFDUixPQUFPO2dCQUNILEdBQUcsS0FBSztnQkFDUixLQUFLLEVBQUUsTUFBTSxDQUFDLE9BQU87YUFDeEIsQ0FBQztRQUNOLEtBQUssUUFBUTtZQUNULE9BQU87Z0JBQ0gsR0FBRyxLQUFLO2dCQUNSLE1BQU0sRUFBRSxNQUFNLENBQUMsT0FBTzthQUN6QixDQUFDO1FBQ04sS0FBSyxPQUFPO1lBQ1IsT0FBTyxFQUFFLEdBQUcsNkJBQTZCLEVBQUUsQ0FBQztRQUNoRDtZQUNJLE9BQU8sS0FBSyxDQUFDO0lBQ3JCLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixNQUFNLHdCQUF3QixHQUFHLENBQzdCLEtBQTZCLEVBQzdCLE1BQStCLEVBQ1QsRUFBRTtJQUN4QixNQUFNLFFBQVEsR0FBRyxPQUFPLENBQUMsS0FBSyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3hDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEtBQUssYUFBYSxFQUFFLENBQUM7UUFDekMsc0NBQXNDO1FBQ3RDLE9BQU8sQ0FBQyxHQUFHLENBQUMsNEJBQTRCLEVBQUUsaUNBQWlDLEVBQUUsTUFBTSxFQUFFLFdBQVcsRUFBRSxRQUFRLENBQUMsQ0FBQztJQUNoSCxDQUFDO0lBQ0QsT0FBTyxRQUFRLENBQUM7QUFDcEIsQ0FBQyxDQUFDO0FBRUYsZUFBZSx3QkFBd0IsQ0FBQyJ9